import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { EmailTemplateDesignerComponent } from './email-template-designer.component';
import { EmailEditorModule } from 'angular-email-editor';

const routes: Routes = [
  {
    path: '',
    component: EmailTemplateDesignerComponent,
    data: { title: 'Email/SMS Template Designer' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmailTemplateDesignerRoutingModule {}

@NgModule({
  imports: [
    EmailTemplateDesignerRoutingModule,
    EmailEditorModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [EmailTemplateDesignerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailTemplateDesignerModule {}
